/* nx-drive.js — All Brands 首屏背景：速写画风的车在开
 *
 * 取代原来那 6 条 CSS 光束。
 *
 * 为什么是纯矢量不带图：车身线稿是从侧视照片里提取的路径（连通域 + Moore 边界
 * 跟踪 + Douglas-Peucker），轮子直接画圆和辐条。整个场景 0 张图片 —— 地面、
 * 路边杆子、远山全是这里现算的。加起来比一张车图还小。
 *
 * 为什么用侧视图：侧视图的轮子是正圆，转起来才对。前 3/4 视角的轮子是椭圆，硬转会歪。
 *
 * 方向：车头朝左 = 往左开。所以世界往右退，轮子逆时针（屏幕 y 向下，
 * SVG rotate 正值是顺时针，往左滚的轮子顶部向左走 → 取负）。
 */
(function () {
  var host = document.getElementById("nxs-drive");
  if (!host || host.dataset.nxDriveOn) return;
  host.dataset.nxDriveOn = "1";

  var CAR = {"w":1209,"h":339,"groups":[{"name":"轮廓","stroke":2,"paths":["M 594 4 L 639 4 L 666 6 L 746 16 L 807 27 L 818 26 L 831 29 L 836 33 L 864 37 L 868 39 L 882 40 L 889 43 L 901 44 L 903 46 L 906 45 L 910 47 L 917 47 L 919 49 L 949 53 L 953 55 L 959 55 L 1014 68 L 1043 71 L 1055 74 L 1092 77 L 1140 69 L 1152 69 L 1162 67 L 1169 69 L 1174 72 L 1178 79 L 1187 79 L 1193 81 L 1188 87 L 1190 91 L 1187 97 L 1187 106 L 1182 121 L 1181 138 L 1184 143 L 1188 171 L 1194 188 L 1194 202 L 1191 220 L 1195 223 L 1202 224 L 1200 233 L 1193 250 L 1191 251 L 1187 264 L 1181 270 L 1163 276 L 1127 283 L 1120 286 L 1070 291 L 1056 309 L 1045 317 L 1041 318 L 1038 322 L 1027 328 L 1025 333 L 1002 334 L 974 332 L 973 333 L 972 329 L 967 330 L 965 328 L 964 330 L 963 327 L 960 328 L 958 325 L 956 327 L 953 327 L 951 326 L 953 324 L 952 323 L 949 322 L 948 324 L 946 324 L 924 308 L 912 292 L 892 290 L 892 297 L 882 297 L 880 293 L 873 293 L 873 295 L 877 296 L 875 295 L 872 297 L 863 295 L 861 295 L 860 297 L 843 297 L 842 295 L 839 297 L 804 297 L 768 295 L 699 296 L 695 294 L 442 294 L 441 292 L 438 292 L 437 294 L 434 292 L 430 294 L 413 294 L 412 292 L 410 294 L 401 294 L 403 293 L 402 292 L 397 293 L 399 294 L 394 294 L 396 293 L 347 291 L 344 293 L 344 295 L 344 291 L 346 288 L 338 287 L 335 291 L 338 293 L 333 299 L 325 298 L 322 301 L 317 301 L 318 299 L 316 298 L 305 309 L 305 315 L 302 316 L 302 319 L 301 318 L 298 321 L 296 325 L 298 326 L 230 327 L 223 325 L 220 326 L 215 321 L 213 322 L 199 315 L 195 312 L 194 309 L 192 310 L 186 305 L 173 289 L 163 289 L 161 291 L 156 292 L 153 296 L 139 294 L 91 294 L 79 291 L 63 291 L 50 289 L 47 287 L 44 288 L 26 286 L 23 284 L 22 285 L 5 282 L 20 274 L 20 260 L 28 258 L 40 252 L 44 248 L 40 231 L 37 228 L 36 224 L 33 221 L 29 220 L 22 203 L 23 197 L 19 194 L 18 188 L 43 167 L 71 150 L 88 143 L 92 139 L 98 138 L 105 134 L 122 132 L 128 129 L 160 121 L 171 121 L 172 119 L 192 115 L 223 106 L 227 107 L 242 103 L 244 104 L 259 101 L 272 101 L 276 99 L 286 98 L 288 100 L 294 100 L 295 98 L 314 98 L 317 96 L 338 97 L 429 52 L 442 48 L 454 41 L 459 40 L 468 35 L 474 34 L 481 30 L 500 24 L 508 23 L 510 19 L 558 8 L 581 5 L 593 5 Z"],"pts":217},{"name":"内部·深","stroke":1.5,"paths":["M 509 22 L 524 25 L 487 39 L 446 59 L 407 81 L 402 81 L 398 84 L 400 85 L 399 86 L 367 106 L 328 107 L 322 106 L 319 102 L 317 102 L 312 107 L 298 105 L 292 102 L 299 102 L 297 103 L 300 104 L 306 102 L 308 99 L 312 101 L 312 98 L 315 97 L 317 101 L 322 103 L 339 97 L 417 58 L 436 50 L 438 51 L 439 49 L 440 50 L 455 41 L 481 30 L 508 23 Z","M 597 25 L 652 26 L 729 34 L 761 39 L 775 46 L 774 47 L 779 51 L 731 77 L 713 82 L 681 87 L 564 100 L 466 108 L 463 108 L 466 107 L 469 104 L 468 103 L 443 104 L 441 102 L 438 103 L 437 100 L 434 101 L 437 98 L 438 94 L 436 92 L 428 92 L 416 95 L 425 82 L 427 83 L 440 77 L 446 76 L 440 84 L 440 88 L 449 78 L 452 77 L 467 75 L 470 82 L 471 77 L 469 71 L 472 71 L 478 66 L 481 66 L 504 53 L 500 52 L 484 59 L 469 67 L 467 70 L 459 70 L 460 69 L 498 50 L 522 40 L 561 29 L 583 26 L 596 26 Z","M 1162 67 L 1173 71 L 1178 80 L 1191 80 L 1192 82 L 1186 88 L 1177 89 L 1119 81 L 1126 80 L 1124 78 L 1120 79 L 1122 78 L 1150 71 L 1153 72 L 1155 70 L 1154 69 L 1134 72 L 1117 78 L 1100 76 L 1141 69 L 1161 68 Z","M 428 99 L 432 99 L 433 100 L 431 100 L 431 102 L 443 107 L 439 107 L 439 109 L 448 109 L 437 109 L 435 111 L 436 113 L 433 116 L 436 117 L 433 117 L 432 119 L 405 112 L 411 112 L 436 106 L 428 101 L 420 102 L 427 100 Z","M 1143 101 L 1167 104 L 1176 107 L 1177 109 L 1172 118 L 1172 122 L 1175 128 L 1169 126 L 1168 123 L 1170 126 L 1172 125 L 1169 119 L 1163 119 L 1170 113 L 1171 110 L 1169 109 L 1172 108 L 1165 105 L 1162 106 L 1155 116 L 1161 127 L 1148 124 L 1141 113 L 1142 115 L 1149 116 L 1159 106 L 1158 104 L 1149 102 L 1138 103 L 1132 110 L 1130 110 L 1128 114 L 1130 120 L 1137 128 L 1150 134 L 1161 134 L 1164 132 L 1170 134 L 1176 133 L 1177 131 L 1177 134 L 1148 135 L 1137 133 L 1104 124 L 1087 115 L 1121 115 L 1135 104 L 1120 104 L 1097 108 L 1101 106 L 1121 103 L 1142 102 Z","M 638 119 L 697 127 L 756 139 L 741 140 L 737 138 L 736 143 L 763 143 L 767 148 L 782 157 L 789 166 L 796 171 L 809 185 L 812 187 L 813 186 L 821 195 L 812 204 L 789 218 L 775 222 L 757 223 L 778 204 L 781 200 L 781 197 L 777 193 L 776 196 L 763 195 L 763 190 L 773 189 L 756 172 L 736 157 L 734 160 L 729 184 L 734 158 L 731 153 L 729 152 L 727 154 L 719 154 L 715 150 L 708 148 L 699 148 L 683 142 L 658 137 L 653 134 L 636 130 L 617 123 L 619 123 L 619 121 L 637 120 Z","M 243 145 L 268 147 L 287 153 L 311 168 L 329 188 L 340 209 L 346 230 L 348 243 L 348 275 L 346 286 L 338 286 L 335 288 L 339 281 L 344 265 L 345 233 L 339 211 L 333 199 L 321 183 L 306 170 L 288 160 L 266 154 L 240 154 L 218 160 L 199 170 L 197 173 L 185 181 L 177 193 L 173 196 L 174 198 L 171 199 L 172 201 L 167 207 L 168 210 L 161 233 L 161 259 L 167 281 L 171 288 L 170 289 L 167 288 L 161 291 L 160 290 L 155 292 L 151 296 L 127 293 L 115 294 L 111 292 L 107 292 L 105 294 L 81 292 L 84 292 L 87 289 L 86 287 L 92 284 L 95 281 L 94 280 L 84 284 L 84 286 L 81 286 L 78 289 L 62 288 L 60 290 L 48 287 L 51 285 L 47 283 L 39 285 L 43 287 L 29 286 L 24 284 L 30 284 L 31 282 L 42 281 L 44 279 L 29 277 L 25 275 L 23 271 L 58 277 L 74 277 L 99 280 L 119 271 L 136 268 L 124 267 L 108 273 L 115 259 L 114 258 L 99 263 L 92 263 L 72 257 L 55 221 L 53 220 L 54 218 L 39 218 L 49 217 L 51 215 L 50 209 L 46 202 L 46 198 L 76 196 L 85 197 L 93 209 L 114 255 L 116 256 L 137 222 L 144 216 L 155 211 L 157 203 L 164 190 L 172 179 L 184 167 L 199 157 L 210 152 L 227 147 L 242 146 Z","M 988 145 L 1015 147 L 1036 154 L 1052 163 L 1072 182 L 1084 202 L 1091 224 L 1093 238 L 1093 277 L 1113 270 L 1128 262 L 1140 247 L 1162 212 L 1168 207 L 1185 202 L 1187 200 L 1186 198 L 1192 194 L 1188 191 L 1188 184 L 1180 150 L 1183 155 L 1189 180 L 1194 190 L 1191 220 L 1194 223 L 1202 224 L 1199 225 L 1189 223 L 1186 227 L 1187 229 L 1200 230 L 1186 265 L 1180 270 L 1170 274 L 1126 283 L 1124 285 L 1069 291 L 1075 279 L 1079 265 L 1080 233 L 1075 213 L 1064 192 L 1048 174 L 1036 165 L 1023 158 L 998 151 L 972 151 L 952 156 L 931 167 L 913 183 L 901 200 L 895 213 L 890 233 L 891 265 L 895 279 L 901 291 L 890 290 L 889 288 L 884 287 L 886 287 L 886 285 L 860 286 L 873 288 L 878 287 L 866 290 L 827 288 L 847 289 L 848 287 L 845 285 L 847 283 L 844 281 L 845 277 L 848 275 L 847 274 L 824 285 L 823 286 L 825 289 L 809 291 L 811 289 L 819 289 L 820 288 L 816 286 L 820 283 L 835 276 L 838 273 L 841 273 L 862 263 L 855 261 L 827 271 L 815 278 L 819 278 L 818 279 L 815 280 L 814 278 L 799 286 L 791 288 L 736 293 L 749 294 L 749 296 L 722 296 L 720 294 L 718 296 L 712 296 L 710 294 L 670 294 L 672 294 L 672 292 L 648 295 L 645 293 L 643 295 L 523 293 L 453 294 L 426 291 L 419 293 L 418 291 L 410 290 L 394 290 L 394 292 L 407 292 L 381 292 L 380 290 L 370 290 L 378 290 L 378 288 L 375 288 L 377 287 L 406 284 L 558 283 L 685 279 L 714 281 L 738 274 L 757 271 L 760 269 L 788 263 L 874 251 L 879 251 L 882 254 L 884 272 L 887 284 L 889 285 L 890 282 L 887 263 L 889 230 L 895 209 L 908 186 L 922 171 L 942 157 L 962 149 L 977 146 L 987 146 Z","M 1157 148 L 1161 152 L 1160 155 L 1162 159 L 1163 177 L 1160 186 L 1151 193 L 1154 172 L 1159 169 L 1155 169 L 1155 165 L 1159 163 L 1156 162 L 1156 157 L 1159 156 L 1157 155 L 1157 149 Z"],"pts":511},{"name":"内部·中","stroke":1.1,"paths":["M 509 22 L 525 25 L 499 34 L 462 51 L 405 82 L 367 106 L 330 107 L 328 109 L 295 106 L 280 107 L 294 106 L 292 102 L 299 101 L 296 99 L 310 99 L 310 97 L 322 96 L 328 100 L 339 97 L 429 52 L 437 49 L 438 51 L 439 48 L 441 49 L 450 43 L 481 30 L 508 23 Z","M 591 25 L 640 25 L 724 33 L 759 38 L 778 47 L 780 51 L 737 75 L 698 85 L 537 103 L 473 108 L 459 108 L 466 107 L 466 105 L 446 106 L 443 108 L 456 108 L 438 109 L 434 115 L 441 118 L 444 124 L 438 124 L 400 110 L 409 111 L 414 108 L 412 104 L 407 104 L 399 108 L 396 107 L 414 95 L 418 102 L 423 101 L 428 94 L 416 94 L 423 83 L 428 79 L 432 80 L 447 76 L 441 83 L 442 85 L 451 77 L 466 75 L 466 73 L 459 73 L 467 73 L 466 70 L 456 71 L 509 45 L 554 30 L 590 26 Z","M 1162 67 L 1173 71 L 1178 79 L 1192 80 L 1192 82 L 1188 88 L 1174 89 L 1116 81 L 1113 80 L 1113 78 L 1098 76 L 1141 69 L 1161 68 Z","M 1138 100 L 1152 100 L 1153 102 L 1160 103 L 1166 102 L 1179 106 L 1172 119 L 1177 134 L 1140 134 L 1103 124 L 1087 115 L 1103 105 L 1137 101 Z","M 634 119 L 712 129 L 757 139 L 772 148 L 776 148 L 775 150 L 796 168 L 819 191 L 821 196 L 811 205 L 787 219 L 770 223 L 757 223 L 777 203 L 776 202 L 771 204 L 737 191 L 733 188 L 731 179 L 723 202 L 727 190 L 728 177 L 725 178 L 721 176 L 703 162 L 671 143 L 614 122 L 633 120 Z","M 139 132 L 141 132 L 121 144 L 113 155 L 62 166 L 72 159 L 69 162 L 70 164 L 99 158 L 102 154 L 100 151 L 91 153 L 78 160 L 107 144 L 138 133 Z","M 239 145 L 264 146 L 290 154 L 309 166 L 325 182 L 340 208 L 345 223 L 348 241 L 348 280 L 380 278 L 366 193 L 365 159 L 366 192 L 380 277 L 382 279 L 446 275 L 443 273 L 431 273 L 430 268 L 413 256 L 411 251 L 403 250 L 473 255 L 513 255 L 693 239 L 697 241 L 705 238 L 823 228 L 719 260 L 678 269 L 661 276 L 628 275 L 581 279 L 450 281 L 442 282 L 442 284 L 664 279 L 715 280 L 783 263 L 876 250 L 882 253 L 888 282 L 888 233 L 895 208 L 906 188 L 926 167 L 941 157 L 960 149 L 980 145 L 1006 145 L 1033 152 L 1053 163 L 1068 176 L 1084 200 L 1090 218 L 1094 245 L 1094 271 L 1128 261 L 1145 239 L 1163 210 L 1169 206 L 1183 202 L 1184 199 L 1191 194 L 1188 191 L 1179 150 L 1181 150 L 1184 155 L 1189 178 L 1194 190 L 1191 220 L 1194 223 L 1202 225 L 1186 265 L 1178 271 L 1154 278 L 1126 283 L 1124 285 L 1069 291 L 1079 265 L 1080 233 L 1075 213 L 1064 192 L 1048 174 L 1023 158 L 998 151 L 972 151 L 952 156 L 931 167 L 913 183 L 901 200 L 895 213 L 890 233 L 891 265 L 901 291 L 891 290 L 890 292 L 881 293 L 870 292 L 869 290 L 865 291 L 868 292 L 864 292 L 863 290 L 854 291 L 852 293 L 796 293 L 793 295 L 836 295 L 828 295 L 827 297 L 826 295 L 769 296 L 788 295 L 788 293 L 753 293 L 755 296 L 751 296 L 750 293 L 749 296 L 722 296 L 720 294 L 718 296 L 712 296 L 710 294 L 669 293 L 615 295 L 357 292 L 351 291 L 378 290 L 378 288 L 372 287 L 428 281 L 422 280 L 486 277 L 451 276 L 351 280 L 347 282 L 347 288 L 346 286 L 338 286 L 335 288 L 344 265 L 345 233 L 339 211 L 329 193 L 310 173 L 288 160 L 266 154 L 240 154 L 218 160 L 200 170 L 185 183 L 173 199 L 167 211 L 161 233 L 161 259 L 170 289 L 160 290 L 151 296 L 127 293 L 115 294 L 111 292 L 98 294 L 24 284 L 30 283 L 31 281 L 39 281 L 39 279 L 28 279 L 24 281 L 23 279 L 21 283 L 7 282 L 13 277 L 20 275 L 21 272 L 30 270 L 24 269 L 61 270 L 52 270 L 53 272 L 44 273 L 66 276 L 74 271 L 68 270 L 83 270 L 75 271 L 80 272 L 78 277 L 98 279 L 107 275 L 108 268 L 114 260 L 90 263 L 74 259 L 69 253 L 61 235 L 59 236 L 51 231 L 45 225 L 43 219 L 38 218 L 51 213 L 47 204 L 43 205 L 31 199 L 35 215 L 33 221 L 29 220 L 22 202 L 23 199 L 28 197 L 53 198 L 84 196 L 94 210 L 116 256 L 136 223 L 142 217 L 155 210 L 163 191 L 179 171 L 195 159 L 209 152 L 226 147 L 238 146 Z","M 1158 145 L 1176 148 L 1161 152 L 1164 175 L 1159 188 L 1150 193 L 1154 176 L 1157 146 Z"],"pts":379}]};

  var NS = "http://www.w3.org/2000/svg";
  var VW = 1600, VH = 520;
  var GROUND = 430;                    // 画面里的地平线
  var SC = 0.88;                       // 车的缩放。纸白稿上标题挪到左上角了，车可以放大
  var CAR_X = 250;
  var CAR_Y = GROUND - CAR.h * SC;     // 让轮子正好落在地平线上

  // 轮子（原图坐标，会跟着 SC 一起缩）
  var WHEELS = [
    { cx: 253, cy: 246, r: 88, spokes: 5 },
    { cx: 985, cy: 246, r: 91, spokes: 5 }
  ];

  // 线条颜色从后台设置来。Shopify 的取色器给的是 hex，这里拆成 rgb 再配透明度 ——
  // 车身线比背景线实一档，不然远山和地面会跟车抢。
  function rgba(hex, a) {
    var h = String(hex || "").trim().replace("#", "");
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    var n = parseInt(h, 16);
    if (h.length !== 6 || isNaN(n)) return "rgba(232,232,236," + a + ")";
    return "rgba(" + ((n >> 16) & 255) + "," + ((n >> 8) & 255) + "," + (n & 255) + "," + a + ")";
  }
  var BLUR_N = 5;              // 模糊叠几份
  var SHUTTER = 1 / 15;        // 等效快门。物理上该是 1/48 左右，但本场景的
                               // 表观车速偏慢，用长一点的快门才糊得出「在滚」的感觉
  var HEX = host.dataset.color || "#23232b";   // 纸白底，默认墨色
  var LINE = rgba(HEX, 0.88);
  var LINE_BG = rgba(HEX, 0.34);

  function el(n, a) {
    var e = document.createElementNS(NS, n);
    for (var k in a) e.setAttribute(k, a[k]);
    return e;
  }

  var svg = el("svg", {
    viewBox: "0 0 " + VW + " " + VH,
    preserveAspectRatio: "xMidYMax meet",
    "aria-hidden": "true", focusable: "false"
  });
  host.appendChild(svg);

  var gFar = el("g", {}), gMid = el("g", {}), gGround = el("g", {}), gCar = el("g", {});
  svg.appendChild(gFar); svg.appendChild(gMid); svg.appendChild(gGround); svg.appendChild(gCar);

  // ── 视差层 ──
  // 份数必须按画面宽度算：写死 2 份的话 tile=300 只铺 600px，右边是空的
  function tiles(g, tile, draw) {
    var reps = Math.ceil((VW + tile) / tile) + 1;
    for (var r = 0; r < reps; r++) {
      var sub = el("g", { transform: "translate(" + (r * tile - tile) + ",0)" });
      draw(sub, r);
      g.appendChild(sub);
    }
    return { g: g, tile: tile };
  }
  function scroll(t, dist, k) {
    var off = (((dist * k) % t.tile) + t.tile) % t.tile;
    t.g.setAttribute("transform", "translate(" + (off - t.tile) + ",0)");
  }

  var far = tiles(gFar, 1600, function (g) {
    // Seattle skyline: downtown towers + Space Needle + Smith Tower, with
    // Mt. Rainier ghosted behind. line/polyline only - the sketch<->photo
    // recolor walks those tags.
    var B = GROUND - 100;
    function ln(pts, w, o) {
      g.appendChild(el("polyline", { points: pts.map(function (p) { return p.join(","); }).join(" "),
        fill: "none", stroke: LINE_BG, "stroke-width": w, opacity: o }));
    }
    // Mt. Rainier - broad snow dome, farthest and faintest
    ln([[980,B-6],[1090,B-64],[1170,B-110],[1238,B-140],[1300,B-146],[1362,B-134],[1442,B-92],[1560,B-12]], 1, 0.15);
    ln([[1238,B-140],[1260,B-127],[1286,B-137],[1312,B-129],[1338,B-138],[1362,B-134]], 1, 0.15);
    // foothill ridge running behind downtown
    ln([[0,B-20],[190,B-30],[430,B-18],[720,B-34],[980,B-20],[1240,B-28],[1600,B-20]], 1, 0.18);
    // back row - low blocks, one step fainter
    [[40,44,34],[130,58,52],[250,40,40],[560,52,58],[760,46,42],[1060,56,36],[1210,44,30],[1480,60,38]]
      .forEach(function (b) { ln([[b[0],B],[b[0],B-b[2]],[b[0]+b[1],B-b[2]],[b[0]+b[1],B]], 1, 0.24); });
    // front skyline
    function tw(x, w, h, ant) {
      ln([[x,B],[x,B-h],[x+w,B-h],[x+w,B]], 1.1, 0.45);
      if (ant) ln([[x+w/2,B-h],[x+w/2,B-h-ant]], 1, 0.45);
    }
    tw(70,54,92); tw(148,40,118,14); tw(206,64,80);
    // setback tower
    ln([[296,B],[296,B-104],[310,B-104],[310,B-138],[336,B-138],[336,B-104],[350,B-104],[350,B]], 1.1, 0.45);
    tw(494,58,106); tw(578,36,86);
    tw(636,70,148,12);                     // the tall dark one downtown
    tw(736,48,120); tw(806,60,94);
    // Smith Tower - slim shaft with a pyramid cap
    tw(888,34,110);
    ln([[888,B-110],[905,B-134],[922,B-110]], 1.1, 0.45);
    tw(948,52,78);
    // waterfront: two sheds + a port crane on the right, under Rainier
    ln([[1330,B],[1330,B-26],[1396,B-26],[1396,B]], 1, 0.34);
    ln([[1420,B],[1420,B-20],[1470,B-20],[1470,B]], 1, 0.34);
    ln([[1508,B],[1508,B-64],[1560,B-40]], 1, 0.34);
    ln([[1508,B-48],[1544,B-48]], 1, 0.34);
    // window ticks on three towers
    [[168,118],[660,148],[758,120]].forEach(function (t) {
      for (var y = 22; y < t[1] - 12; y += 20) ln([[t[0],B-y],[t[0]+14,B-y]], 1, 0.28);
    });
    // Space Needle at x=430, above everything nearby
    var x = 430;
    ln([[x-24,B],[x-7,B-96]], 1.2, 0.5); ln([[x+24,B],[x+7,B-96]], 1.2, 0.5);
    ln([[x-3,B-8],[x-3,B-96]], 1, 0.4); ln([[x+3,B-8],[x+3,B-96]], 1, 0.4);
    ln([[x-15,B-56],[x+15,B-56]], 1, 0.4);
    ln([[x-7,B-96],[x-7,B-138]], 1.2, 0.5); ln([[x+7,B-96],[x+7,B-138]], 1.2, 0.5);
    ln([[x-30,B-138],[x-35,B-146],[x-24,B-155],[x+24,B-155],[x+35,B-146],[x+30,B-138],[x-30,B-138]], 1.2, 0.5);
    ln([[x-8,B-155],[x,B-171],[x+8,B-155]], 1.2, 0.5);
    ln([[x,B-171],[x,B-184]], 1.2, 0.5);
  });

  var mid = tiles(gMid, 520, function (g) {
    for (var x = 40; x < 520; x += 168) {
      g.appendChild(el("line", { x1: x, y1: GROUND - 6, x2: x, y2: GROUND - 104,
        stroke: LINE_BG, "stroke-width": 1.3, opacity: .5 }));
      g.appendChild(el("line", { x1: x - 18, y1: GROUND - 104, x2: x + 7, y2: GROUND - 108,
        stroke: LINE_BG, "stroke-width": 1.3, opacity: .5 }));
    }
  });

  var grd = tiles(gGround, 320, function (g) {
    for (var x = 0; x < 320; x += 12) {
      var h = 5 + (x % 36) * 0.5;
      g.appendChild(el("line", { x1: x, y1: GROUND + 7, x2: x - 10, y2: GROUND + 7 + h,
        stroke: LINE_BG, "stroke-width": 1, opacity: .45 }));
    }
    // data-main 标记：切实拍时这条地平线要跟车身一起反色，比背景线亮一档
    g.appendChild(el("line", { x1: 0, y1: GROUND, x2: 320, y2: GROUND,
      stroke: LINE, "stroke-width": 1.4, opacity: .7, "data-main": "1" }));
    g.appendChild(el("line", { x1: 34, y1: GROUND + 30, x2: 178, y2: GROUND + 30,
      stroke: LINE_BG, "stroke-width": 2.4, opacity: .45 }));
  });

  // ── 车 ──
  var carRoot = el("g", { transform: "translate(" + CAR_X + "," + CAR_Y + ") scale(" + SC + ")" });
  gCar.appendChild(carRoot);
  var carBob = el("g", {});
  carRoot.appendChild(carBob);

  // ── 照片层（车身）──
  // href 先留空，等「画风」滑块第一次离开 0 才灌进去 ——
  // 87KB 的图不该让只想看线稿的人先下载一遍。
  var PH = { body: host.dataset.body, wf: host.dataset.wf, wr: host.dataset.wr };
  var imgBody = el("image", { x: 0, y: 0, width: CAR.w, height: CAR.h, opacity: 0 });
  carBob.appendChild(imgBody);            // 先加 = 压在线稿下面

  // ── 线稿层（车身）──
  var gInk = el("g", {});
  carBob.appendChild(gInk);
  CAR.groups.forEach(function (grp) {
    grp.paths.forEach(function (d) {
      gInk.appendChild(el("path", { d: d, fill: "none", stroke: LINE,
        "stroke-width": grp.stroke, "stroke-linejoin": "round", "stroke-linecap": "round" }));
    });
  });

  // ── 轮子 ──
  //
  // 关键决定：**照片轮盘不转。**
  // 转照片之所以假，是因为高光和卡钳被烤在图里了 —— 真车上光源是固定的、
  // 卡钳是固定的，只有轮辋在转。整张图一起转，等于让光源和卡钳绕着轮心公转，
  // 眼睛一看就知道不对。
  //
  // 所以照片保持静止（物理正确），运动全部交给画上去的「转动层」：
  // 几道同心圆弧在转，那正是真实轮子高速时眼睛看到的东西 —— 辐条糊成的弧线。
  //
  // 线稿模式下辐条可以照转 —— 它是画的，没有烤死的光照，转起来没有破绽。
  var wheelGs = WHEELS.map(function (w) {
    // 1 · 照片圆盘（静止）
    var im = el("image", { x: w.cx - w.r, y: w.cy - w.r,
      width: w.r * 2, height: w.r * 2, opacity: 0 });
    carBob.appendChild(im);

    // 2 · 线稿轮（会转，带角向模糊叠影）
    var ink = el("g", {});
    ink.appendChild(el("circle", { cx: w.cx, cy: w.cy, r: w.r - 2, fill: "none",
      stroke: LINE, "stroke-width": 2.2 }));
    ink.appendChild(el("circle", { cx: w.cx, cy: w.cy, r: w.r * 0.62, fill: "none",
      stroke: LINE, "stroke-width": 1.3 }));
    for (var i = 0; i < w.spokes; i++) {
      var a = i / w.spokes * Math.PI * 2;
      ink.appendChild(el("line", {
        x1: w.cx + Math.cos(a) * w.r * 0.18, y1: w.cy + Math.sin(a) * w.r * 0.18,
        x2: w.cx + Math.cos(a) * w.r * 0.60, y2: w.cy + Math.sin(a) * w.r * 0.60,
        stroke: LINE, "stroke-width": 1.5, "stroke-linecap": "round" }));
    }
    ink.appendChild(el("circle", { cx: w.cx, cy: w.cy, r: w.r * 0.16, fill: "none",
      stroke: LINE, "stroke-width": 1.5 }));
    // 角向模糊：叠 N 份不同角度。速度一高，每帧转过的角度接近辐条间距（5 根 = 72°），
    // 不糊就会出现车轮倒转错觉。
    var inkStack = el("g", {});
    var inkCopies = [];
    for (var c = 0; c < BLUR_N; c++) {
      var cg = el("g", { opacity: (1 / BLUR_N).toFixed(3) });
      cg.appendChild(ink.cloneNode(true));
      inkStack.appendChild(cg);
      inkCopies.push(cg);
    }
    carBob.appendChild(inkStack);

    // 3 · 转动层：同心圆弧，两种画风下都用。这是「在滚」的主要视觉线索。
    var spin = el("g", { opacity: 0 });
    // 12 道细弧比 5 道粗弧真实得多：真实的辐条糊影是一层密而淡的纹理，
    // 不是几条看得清的线。半径覆盖辐条所在的 0.30–0.92R，角度和长度都错开。
    for (var k = 0; k < 12; k++) {
      var rr = 0.30 + (k % 6) * 0.124 + (k > 5 ? 0.03 : 0);
      var R = w.r * rr;
      var span = 42 + ((k * 37) % 95);
      var a0 = ((k * 137) % 360) * Math.PI / 180;
      var a1 = a0 + span * Math.PI / 180;
      var d = "M " + (w.cx + Math.cos(a0) * R).toFixed(1) + " " + (w.cy + Math.sin(a0) * R).toFixed(1)
            + " A " + R.toFixed(1) + " " + R.toFixed(1) + " 0 0 1 "
            + (w.cx + Math.cos(a1) * R).toFixed(1) + " " + (w.cy + Math.sin(a1) * R).toFixed(1);
      spin.appendChild(el("path", { d: d, fill: "none",
        "stroke-width": (1.2 + (k % 4) * 0.45).toFixed(2),
        "stroke-linecap": "round",
        opacity: (0.07 + (k % 3) * 0.025).toFixed(3), "data-arc": "1" }));
    }
    carBob.appendChild(spin);

    return { im: im, inkStack: inkStack, inkCopies: inkCopies,
             inkNodes: inkCopies.map(function (cc) { return cc.firstChild; }),
             spin: spin, w: w, ang: 0 };
  });

  var photoLoaded = false;
  function href(node, url) {
    node.setAttributeNS("http://www.w3.org/1999/xlink", "href", url);
    node.setAttribute("href", url);
  }
  function loadPhotos() {
    if (photoLoaded || !PH.body) return;
    photoLoaded = true;
    href(imgBody, PH.body);
    href(wheelGs[0].im, PH.wf);     // 照片轮盘各只有一份（它不转，不需要叠影）
    href(wheelGs[1].im, PH.wr);
  }

  // ── 页面上的两个滑块 ──
  // 放在页面上而不是后台：这是给客户玩的，不是给店主配的。
  var elSpeed = document.getElementById("nxs-drive-speed");
  var elStyle = document.getElementById("nxs-drive-style");
  var outSpeed = document.getElementById("nxs-drive-speed-v");
  var outStyle = document.getElementById("nxs-drive-style-v");
  var hero = host.closest(".hero") || host.parentNode;

  var V0 = +(host.dataset.speed || 620);         // 后台设的默认速度
  var PAPER = host.dataset.paper || "#f6f4ef";
  var DARKBG = "#0f0f14";

  function hex2rgb(h) {
    h = String(h || "").replace("#", "");
    if (h.length === 3) h = h[0]+h[0]+h[1]+h[1]+h[2]+h[2];
    var n = parseInt(h, 16);
    return isNaN(n) ? [246,244,239] : [(n>>16)&255, (n>>8)&255, n&255];
  }
  var RGB_PAPER = hex2rgb(PAPER), RGB_DARK = hex2rgb(DARKBG);

  var style = 0;                                  // 0 = 线稿, 1 = 实拍
  function readStyle() {
    style = elStyle ? +elStyle.value / 100 : 0;
    if (style > 0) loadPhotos();
    if (outStyle) outStyle.textContent = Math.round(style * 100) + "%";
    applyStyle();
  }
  function applyStyle() {
    var s = style;
    gInk.setAttribute("opacity", 1 - s);
    imgBody.setAttribute("opacity", s);
    wheelGs.forEach(function (o) {
      o.inkStack.setAttribute("opacity", 1 - s);
      o.im.setAttribute("opacity", s);
      // 转动弧的颜色跟着画风走：照片上的黑轮子要浅色弧，纸白线稿上要墨色弧
      var col = s > 0.5 ? "rgba(255,255,255,.9)" : LINE;
      [].forEach.call(o.spin.querySelectorAll("[data-arc]"), function (p) {
        p.setAttribute("stroke", col);
      });
    });
    // 背景从纸白渐到深色，线稿的地面/远山跟着反色
    var bg = RGB_PAPER.map(function (c, i) { return Math.round(c + (RGB_DARK[i] - c) * s); });
    hero.style.backgroundColor = "rgb(" + bg.join(",") + ")";
    hero.classList.toggle("is-photo", s > 0.55);
    // 实拍模式下背景线要反过来才看得见
    var bgLine = s > 0.55 ? "rgba(232,232,236,.26)" : LINE_BG;
    [gFar, gMid, gGround].forEach(function (g) {
      [].forEach.call(g.querySelectorAll("line,polyline"), function (n) {
        n.setAttribute("stroke", n.dataset.main ? (s > 0.55 ? "rgba(232,232,236,.5)" : LINE) : bgLine);
      });
    });
  }
  if (elStyle) elStyle.addEventListener("input", readStyle);
  if (elSpeed) elSpeed.addEventListener("input", function () {
    if (outSpeed) outSpeed.textContent = elSpeed.value;
  });

  // ── 循环 ──
  var dist = 0, bob = 0, last = null, raf = 0, visible = true;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function draw(dt) {
    var V = elSpeed ? +elSpeed.value : V0;
    dist += V * dt;
    bob += dt * 2.6;

    scroll(far, dist, 0.10);
    scroll(mid, dist, 0.42);
    scroll(grd, dist, 1.00);

    wheelGs.forEach(function (o) {
      // ω = v / r —— 转速和地面滚动严格挂钩，不会出现空转或打滑。
      // 除以 SC 是因为 r 是原图坐标，而 dist 走的是 viewBox 坐标。
      var wDeg = (V / (o.w.r * SC)) * (180 / Math.PI);   // 角速度 °/s
      o.ang -= wDeg * dt;
      var rot = "rotate(" + o.ang.toFixed(2) + "," + o.w.cx + "," + o.w.cy + ")";

      // 线稿辐条：转 + 角向模糊叠影
      var spread = Math.min(26, wDeg * SHUTTER);
      o.inkCopies.forEach(function (cg, i) {
        var off = BLUR_N === 1 ? 0 : (i / (BLUR_N - 1) - 0.5) * spread;
        cg.setAttribute("transform",
          "rotate(" + (o.ang + off).toFixed(2) + "," + o.w.cx + "," + o.w.cy + ")");
      });

      // 转动层：照片是静止的，全靠这几道弧表达「在滚」。
      // 静止时完全隐藏（那时该看到的是一个清晰不动的轮子），随速度淡入。
      o.spin.setAttribute("transform", rot);
      o.spin.setAttribute("opacity", Math.min(1, wDeg / 190).toFixed(3));
    });

    // 车身不做悬挂晃动 —— 一晃轮胎就离地/陷地，比不晃更假。
    // 真实感全部交给轮子的圆周运动去表达。
  }

  function tick(ts) {
    if (last === null) last = ts;
    var dt = Math.min(0.05, (ts - last) / 1000);
    last = ts;
    draw(dt);
    raf = requestAnimationFrame(tick);
  }

  function start() { if (!raf && !reduce) { last = null; raf = requestAnimationFrame(tick); } }
  function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }

  if (outSpeed && elSpeed) outSpeed.textContent = elSpeed.value;
  readStyle();                              // 同步滑块初值
  draw(0);                                  // 先画一帧静态的，reduce 模式下就停在这

  // 滚出视口就停 —— 首屏动画没必要在用户看商品网格时还占 CPU
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      visible ? start() : stop();
    }, { threshold: 0 }).observe(host);
  } else start();

  document.addEventListener("visibilitychange", function () {
    document.hidden ? stop() : (visible && start());
  });
})();
